import { Icon } from "utils";
import DropZone, { UploadType } from "../../../Components/DropZone";
import {
  MENU,
  PLUMBING_PLAN,
} from "../../../Constants";
import { useTradeWasteContext } from "../../tradeWasteContext";

interface AttachmentsInterface {
  uploadError: string;
  isRequired: boolean;
}
const Attachments = ({ isRequired, uploadError }: AttachmentsInterface) => {
  const [state, dispatch] = useTradeWasteContext();
  const destroy = () => {
    dispatch({ type: "deleteUploads" })
  };
  const handleDelete = ({ id, type }: { id: string, type?: 'menu' | 'plumbing_plan' }) => {
    dispatch({ type: type === 'menu' ? "removeMenu" : "removePlan", payload: { id } });
  };
  const handleUpload = (upload: UploadType) => {
    if (upload.type === 'menu' && state?.menus.length < 5) {
      dispatch({
        type: "addMenu", payload: { upload }
      });
    }
    if (upload.type === 'plumbing_plan' && state?.plumbingPlans.length < 5) {
      dispatch({
        type: "addPlumbingPlan", payload: { upload }
      });
    }


  };
  return (
    <section>
      <h2>Attachments</h2>
      {
        uploadError && (
          <span className="field-validation-error wc-assist wc-assist--error">
            {uploadError}
          </span>
        )
      }
      <div className="wc-form-item">
        <label className="label-primary" htmlFor="proposed_menu">
          Please attach your menu or proposed menu
        </label>
        <DropZone
          maxFiles={5}
          maxSize={5242880}
          handleDelete={handleDelete}
          handleUpload={handleUpload}
          savedFiles={state?.menus ?? []}
          id={MENU}
          type="menu"
        />
      </div>
      <div className="wc-form-item">
        <label className="label-primary" htmlFor="plumbing_plan">
          Please attach a plumbing plan
          {!isRequired && " (optional)"}
        </label>
        <DropZone
          maxFiles={5}
          maxSize={5242880}
          handleDelete={handleDelete}
          handleUpload={handleUpload}
          savedFiles={state?.plumbingPlans ?? []}
          id={PLUMBING_PLAN}
          type="plumbing_plan"
        />
        <div style={{ textAlign: "right", maxWidth: 620 }}>
          <button className="btn-tertiary btn-mobile" onClick={destroy}>
            <Icon role="presentation" id="#arrow" width="6.057" height="10" fill="#007497" />
            REMOVE All
          </button>
        </div>
      </div>


    </section>
  );
};

export default Attachments;
